import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import {UsersService} from '../service';
import { IUsers } from '../database';
import { LoginService  } from '../service';
@Injectable()
export class MessageService {

    private _getMessageUrl = APIURL+'Message/messages';
    private _deleteUrl = APIURL+'Message/deleteMessage';
    private _addUrl = APIURL+'Message/SendMessage';
    private _getMessageByTextUrl=APIURL+'Message/messagesByText';

    constructor(private _http: Http,public _loginService:LoginService) { 

    }
   getMessageByTextAndSize(text,size):any{
    var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
         formData.append('text',text);
          formData.append('size',size);
          formData.append('senderId',currentUser.UserId+"");
        return this._http.post(this._getMessageByTextUrl,formData )
                            .map((response: Response) => response.json().data)
   }
   add(form:any):any{
    var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
          let formData:FormData = new FormData();
         formData.append('UserId', form.UserId);
         formData.append('subject', form.subject);
         formData.append('message', form.message);
         formData.append('senderId',currentUser.UserId+"");
      return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
   }
    getMessages(UserId): any{
        let formData:FormData = new FormData();
         formData.append('senderId',UserId+"");
        return this._http.post(this._getMessageUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    delete(userId): any{
           let formData:FormData = new FormData();
         formData.append('UserId', userId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
     private handleError(error: Response) {
        
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/message.service.ts